<div class="prices-stats-block" #body>
    @if (showStats() && tiny() && !openMode()) {
    <div style="width: 100%" [class]="isNewOffer() ? 'grayish' : ''">
        <div class="d-flex small-info-block" [title]="'Prices are currently ' + info() + ' - ' + info_2()">
            <div class="price-statistics small visible">
                <div class="price" [ngStyle]="{'transform': 'translateX(' + percent() + '%)'}">
                    <div class="dot"></div>
                </div>
                <div class="statistics" style="width: 50px;">
                    <div class="low"></div>
                    <div class="average"></div>
                    <div class="high"></div>
                </div>
            </div>
        </div>
    </div>
    }
    @if (showStats() && (!tiny() || openMode())) {
    <div style="width: 100%">
        <div class="d-flex small-info-block">
            <div class="price-statistics small"
                 [class]="(statsCollapse() && !openMode() ? 'visible' : 'hidden') + (isNewOffer() ? ' grayish' : '')">
                <div class="price" [ngStyle]="{'transform': 'translateX(' + percent() + '%)'}" *ngIf="!isNewOffer()">
                    <div class="dot"></div>
                </div>
                <div class="statistics" style="width: 80px;">
                    <div class="low"></div>
                    <div class="average"></div>
                    <div class="high"></div>
                </div>
            </div>
            @if (isNewOffer()) {
            <div class="auto short-info" style="padding-top: 2px;">New Price Plan Offer</div>
            }
            @if (!isNewOffer() && selectedOffer() != null) {
            <div class="auto short-info">Prices are currently <b [class]="priceClass()">{{info()}}</b> - {{info_2()}}</div>
            }
            @if (!isNewOffer() && contract() != null) {
            <div class="auto short-info">Prices were <b [class]="priceClass()">{{info()}}</b> - {{info_2()}}</div>
            }
        </div>
    </div>
    @if (!isNewOffer() && !openMode()) {
    <div class="icon-block">
        <a [class]="statsCollapse() ? 'open' : 'collapse'" (click)="changeCollapse()"></a>
    </div>
    }
    }
</div>
@if (!tiny() || openMode()) {
<div class="prices-stats-block"
     [class]="statsCollapse() && !openMode() ? 'prices-closed' : (selectedOffer() != null ? 'prices-open' : 'prices-open on-contract')">
    @if (showStats() && historyData().length > 0) {
    <div>
        <div class="price-statistics">
            <div class="price" [ngStyle]="{'transform': 'translateX(' + percent() + '%)'}">
                <div class="arrow"></div>
                <div class="info">
                    <span>{{price() | currency:'USD':'symbol':'1.5-5'}}</span> is {{info()}}
                </div>
                <div class="dot"></div>
            </div>
            <div class="statistics">
                <div class="low"></div>
                <div class="average"></div>
                <div class="high"></div>
            </div>
            <div class="numbers">
                <div class="min">{{min_price() | currency:'USD':'symbol':'1.5-5'}}</div>
                <div class="max">{{max_price() | currency:'USD':'symbol':'1.5-5'}}</div>
            </div>
        </div>
        @if (selectedOffer() != null) {
        <div class="short-info">The least expensive rates for your current parameters are usually between: {{abs_min_price() | currency:'USD':'symbol':'1.5-5'}} and {{min_price() | currency:'USD':'symbol':'1.5-5'}}</div>
        }
        @if (selectedOffer() != null) {
        <div class="price-history-title">Price history for this search</div>
        }
        @if (contract() != null) {
        <div class="price-history-title">Price history for this price plan</div>
        }
        <div class="price-history">
            <kilowant-charts-home-price-history [view]="view()" [legend]="legend()" [legendTitle]="legendTitle()"
                                                [legendPosition]="legendPosition()" [showGridLines]="false"
                                                [xAxis]="xAxis()" [yAxis]="yAxis()" [xAxisLabel]="xAxisLabel()" [yAxisLabel]="yAxisLabel()"
                                                [scheme]="colorScheme()"
                                                [tooltipDisabled]="true"
                                                [pointDate]="pointDate()"
                                                [pointValue]="pointValue()"
                                                [results]="historyData()">
            </kilowant-charts-home-price-history>
        </div>
    </div>
    }
</div>
}